import { render, staticRenderFns } from "./Friesland.vue?vue&type=template&id=dea679d6&"
var script = {}
import style0 from "./Friesland.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Friesland.vue"
export default component.exports